import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { library, config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { useCookies } from "react-cookie";
import SectionHeroVideo from "../Sections/SectionHeroVideo";
import Header from "./Header";
import Footer from "./Footer";
import CookiesNotice from "../Global/CookiesNotice";
import { gsap, ScrollTrigger } from "gsap/all";
import { globalActions } from "../../context/global";

gsap.registerPlugin(ScrollTrigger);
config.autoAddCss = false;
library.add(fab, fas);

export default function Layout({ children, index, location, settings }) {
  const [cookies] = useCookies(["nf_lang"]);

  const dispatch = useDispatch();

  const storeCountry = useSelector((state) => state.global.country);

  useEffect(() => {
    dispatch(globalActions.setCountry(cookies?.nf_lang));
  }, [cookies, dispatch]);

  // Performed after a render but BEFORE the screen is updated
  useLayoutEffect(() => {
    // Initial Check
    function detectMobile() {
      dispatch(globalActions.setIsMobile());
    }

    // Recheck if mobile on window resize
    if (typeof window !== "undefined") {
      window.addEventListener("resize", detectMobile);
    }

    // Initial set
    dispatch(globalActions.setCountry(cookies?.nf_lang));

    return () => {
      // Remove event listener so we arent checking forever
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", detectMobile);
      }
    };
  }, [dispatch, cookies?.nf_lang]);

  // Force portrait mode
  useEffect(() => {
    window.addEventListener("load", () => {
      //      typeof window !== "undefined" &&
      //        window.screen.orientation.lock("portrait");
    });
  }, []);

  return (
    <div
      className={`${
        storeCountry?.toLowerCase() === "zh" ? "brand-chinese-font" : ""
      }`}
    >
      {index && <SectionHeroVideo data={index} settings={settings} />}
      <Header settings={settings} index={index} />
      <main className="brand-main-content brand-index-top">{children}</main>
      <Footer settings={settings} location={location} />
      <CookiesNotice
        message={settings?.cookies}
        button={settings?.cookies_button}
      />
    </div>
  );
}
